function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      'summary, a[href], button:enabled, [tabindex], [draggable], area, input:not([type=hidden]):not([style*="display:none"]):not([style*="display: none"]):enabled, select:enabled, textarea:enabled, object, iframe'
    )
  ).filter((el, idx) => {
    const tabIndex = parseInt(el.getAttribute('tabindex'));
    if (!tabIndex) {
      return true
    } else {
      return (tabIndex && tabIndex !== -1)
    }
  })
}

const trapFocusHandlers = {}

const removeTrapFocus = (elementToFocus = null) => {
  document.removeEventListener('focusin', trapFocusHandlers.focusin)
  document.removeEventListener('focusout', trapFocusHandlers.focusout)
  document.removeEventListener('keydown', trapFocusHandlers.keydown)

  if (elementToFocus) elementToFocus.focus()
}

const trapFocus = (container, elementToFocus = container, shadowContainer = null) => {
  const elementsContainer = getFocusableElements(container)
  const elementsShadow = shadowContainer ? getFocusableElements(shadowContainer) : []
  const elements = elementsShadow.concat(elementsContainer)
  const first = elements[0]
  const last = elements[elements.length - 1]
  const firstInput = elementsContainer.find(el => el.localName === 'input' || el.localName == 'select')
  const shadowFirstInput = elements.find(el => el.localName === 'input')

  if (!elementToFocus) elementToFocus = shadowFirstInput ? shadowFirstInput : firstInput

  removeTrapFocus()

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return

    document.addEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.focusout = () => {
    document.removeEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.keydown = (event) => {
    if (event.code.toUpperCase() !== 'TAB') return // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault()
      first.focus()
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault()
      last.focus()
    }
  }

  document.addEventListener('focusout', trapFocusHandlers.focusout)
  document.addEventListener('focusin', trapFocusHandlers.focusin)

  setTimeout(function(){ elementToFocus?.focus(); }, 100);
}

const pauseAllMedia = () => {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*'
    )
  })
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*')
  })
  document.querySelectorAll('video').forEach((video) => video.pause())
  document
    .querySelectorAll('product-model')
    .forEach((model) => model.modelViewerUI?.pause())
}

const debounce = (fn, wait) => {
  let t
  return (...args) => {
    clearTimeout(t)
    t = setTimeout(() => fn.apply(this, args), wait)
  }
}

const throttle = (callback, limit) => {
  var waiting = false // Initially, we're not waiting
  return function () {
    // We return a throttled function
    if (!waiting) {
      // If we're not waiting
      callback.apply(this, arguments) // Execute users function
      waiting = true // Prevent future invocations
      setTimeout(function () {
        // After a period of time
        waiting = false // And allow future invocations
      }, limit)
    }
  }
}

const serializeForm = (form) => {
  const obj = {}
  const formData = new FormData(form)
  for (const key of formData.keys()) {
    obj[key] = formData.get(key)
  }
  return JSON.stringify(obj)
}

const fetchConfig = (type = 'json') => {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  }
}

/**
 * Checks to see if the device supports touch gestures.
 */
const isTouch = () => {
  return 'ontouchstart' in window || navigator.maxTouchPoints
}

/**
 * Clones a complex Javascript object. This is a
 * thorough way to ensure that the object is fully
 * cloned with no references kept in place.
 *
 * @param {Object} obj
 */
const deepClone = (obj) => {
  return JSON.parse(JSON.stringify(obj))
}

/**
 * Formats a given integer to a standard fraction.
 *
 * @param {Integer} num A price, with cents
 * @param {Integer} fraction
 */
const formatPrice = (num, fraction = 2) => {
  return (
    '$' +
    (Number(num) / 100).toLocaleString('en-EN', {
      minimumFractionDigits: fraction,
    })
  )
}

/**
 * Removes whitespace within a string and makes all
 * characters lowercase.
 *
 * @param {String} str
 */
const handleize = (str) => str.replace(/[ /_]/g, '-').toLowerCase()

/**
 * Decodes a string that has been encoded through the 'url_encode' Shopify filter
 * @param {*} str
 */
const decode = (str) => decodeURIComponent(str).replace(/\+/g, ' ')

/**
 * Generates a URL that is suitable for the Shopify
 * image CDN. Adds the current image size suffix.
 *
 * @param {*} src
 * @param {*} size
 */
const getImageWithSize = (src = '', size = 1000) => {
  return ('' + src).replace(/([.](?:jpe?g|png))/, `_${size}x$1`)
}

/**
 * Used by components like the product card to select
 * the current product image based on the active color.
 * If there is no active color, a fallback image
 * should be returned if it is defined.
 *
 * @param {*} color
 * @param {*} images
 * @param {*} featured
 * @param {*} fallback
 */
const getProductImage = (
  name = '',
  value = '',
  images,
  featured = false,
  fallback = false
) => {
  const key = `${name}-${(value || '').replace(/[/ ]/g, '-')}`.toLowerCase()
  const image = (images || []).find(({ src }) => {
    return ~src.indexOf(key) && ~src.indexOf(featured ? 'pos-1' : 'pos-2')
  })
  if (!image) {
    return getImageWithSize(fallback, 600)
  }
  return getImageWithSize(image, featured ? 1200 : 600)
}

/**
 * Decode Storefront Product ID, this is used
 * with Storefront API
 *
 * @param {*} src
 * @param {*} size
 */
const decodeIDproduct = (id) => {
  return decodeURIComponent(escape(window.atob(id))).split(
    'gid://shopify/Product/'
  )[1]
}

/**
 * Encode from numerical to Storefront Product ID, this is used
 * with Storefront API
 *
 * @param {*} src
 * @param {*} size
 */
const encodeIDproduct = (id) => {
  return window.btoa('gid://shopify/Product/' + id)
}

/**
 * Decode Storefront Product Variant ID, this is used
 * with Storefront API
 *
 * @param {*} src
 * @param {*} size
 */
const decodeIDproductVariant = (id) => {
  return decodeURIComponent(escape(window.atob(id))).split(
    'gid://shopify/ProductVariant/'
  )[1]
}

/**
 * A very simple helper function that checks
 * a single breakpoint. Note: this is a way to guess
 * at the device type, it is by no means the best way.
 */
const isTablet = () => {
  return window.matchMedia('(min-width: 750px)').matches;
}

const isDesktop = () => {
  return window.matchMedia('(min-width: 990px)').matches;
}

/**
 * Checks if a string is in base64 format, returning boolean
 *
 * @param {string} string String to test
 */
const isBase64 = (string) => {
  const regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/
  return regex.test(string)
}

/**
 * Validates form input completion before toggling the form submit's 'disabled' attribute
 *
 * @param {string} formId ID of form with inputs to validate
 */
 const enableSubmit = (formId) => {
  const form = document.getElementById(formId);
  const inputs = form.getElementsByClassName('js-validate');
  const btn = form.querySelector('button[type="submit"]');
  let isValid = true;

  for (let input of inputs) {
    if (input.type === 'email') {
      isValid = validateEmail(input.value.trim())
    } else if (input.value.trim() === '' || input.value === null) {
      isValid = false
    }
  }

  btn.disabled = !isValid;
}

/**
 * Shallow validation of email input
 *
 * @param {string} email Email string to test
 */
const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

/**
 * Shallow validation of phone input
 *
 * @param {string} phone Phone number string to test
 *
 * Valid formats:
    (123) 456-7890
    (123)456-7890
    123-456-7890
    123.456.7890
    1234567890
    +31636363634
    075-63546725
 *
 */
 const validatePhone = (phone) => {
  return String(phone)
    .toLowerCase()
    .match(
      /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im
    );
};

/**
 * sets a cookie
 *
 * @param {string} name cookie name
 * @param {string} value cookie value
 * @param {int} days (optional) expires in x days
 *
 */
function setCookie(name, value, days) {
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

/**
 * gets a cookie
 *
 * @param {string} name cookie name
 */
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}

/**
 * Refreshes Yotpo widgets
 */
const refreshYotpoWidgets = () => {
 if (
  typeof window.yotpo !== "undefined"
  && window.yotpo
  && window.yotpo.initialized
  ) {
    const api = new Yotpo.API(window.yotpo);
    api.refreshWidgets();
  }
}

/**
 * Observes document until needed element is injected (e.g. useful for third-party apps like Govalo)
 *
 * @param {string} selector element selector e.g. '.js-class' or '#js-id'
 */
const waitForElement = (selector) => {
  return new Promise(resolve => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver(mutations => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
  });
}

/**
 * On click of the 'Quickshop' button in a product tile, open the variant selector
 *
 * @param {string} element The 'Quick Shop' button
 */
const toggleQuickshop = (button) => {
  button.previousElementSibling.querySelector('summary').click()
}

/**
 * On Focus out of the Product card in a collection, complete animation then closing/removing 
 * detail content by toggling click of summarys
 *
 * @param {string} element product card
 */
const focusOutCard = (el) => {
  if (!el.querySelector('details').hasAttribute('open') || typeof el.closest('.collection-grid') === 'undefined') return
  el.querySelector('.product-card__quick-shop--cta').classList.add = 'hidden'
  el.closest('.product-tile-slider').style.pointerEvents = "none";

  setTimeout(() => {
    el.querySelector('details').removeAttribute('open');
    el.querySelector('.product-card__quick-shop--cta').classList.remove = 'hidden'
    el.closest('.product-tile-slider').style.pointerEvents = "auto";
  }, 500)
}
